import { createEvent, createStore } from 'effector';
import { KeycloakTokenParsed } from 'keycloak-js';

export interface User extends KeycloakTokenParsed {
  groups?: string[];
  email?: string;
  num?: string | null;
  firstname?: string;
  secondname?: string;
  middlename?: string;
  given_name?: string;
  family_name?: string;
  name?: string;
  preferred_username?: string;
  phone_number?: string;
  phone?: string;
  worklist?: string | unknown[];
}

export type Coordinate = { latitude?: number; longitude?: number };

export const setUser = createEvent<User>();
export const resetUser = createEvent();
export const setCoordinate = createEvent<Coordinate>();
export const setNoCoordinates = createEvent<boolean>();
export const setAllowAnotherStore = createEvent<boolean>();

export const $user = createStore<User | null>(null)
  .on(setUser, (_, user) => user)
  .reset(resetUser);
export const $coordinate = createStore<Coordinate>({})
  .on(setCoordinate, (_, value) => value)
  .reset(resetUser);
export const $noCoordinates = createStore(false)
  .on(setNoCoordinates, (_, value) => value)
  .reset(resetUser);
export const $allowAnotherStore = createStore(false)
  .on(setAllowAnotherStore, (_, value) => value)
  .reset(resetUser);
